const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="#3D5A80"
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={6}
    className="hover:fill-white"
  >
    <path
      d="M0.21967 5.78033C-0.0732233 5.48744 -0.0732233 5.01256 0.21967 4.71967L4.46967 0.46967C4.76256 0.176777 5.23744 0.176777 5.53033 0.46967L9.78033 4.71967C10.0732 5.01256 10.0732 5.48744 9.78033 5.78033C9.48744 6.07322 9.01256 6.07322 8.71967 5.78033L5 2.06066L1.28033 5.78033C0.987437 6.07322 0.512563 6.07322 0.21967 5.78033Z"
      className="bg-blue hover:bg-white"
    />
  </svg>
);
export default ChevronUpIcon;
